import React, { useState, useEffect } from "react";
import { ReactFlowProvider } from "@xyflow/react";
import PageTop from "@/Pages/Project/PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DesignValue from "@/Components/DesignValue/DesignValue";

const Compare = (props: any) => {
  return (
    <ReactFlowProvider>
      
          <PageTop
            mainContent={
              <div className="settingSelectorArea">
                <PageSeletor />
              </div>
            }
          />
          <div className="mainContent">
            <div className="mainTask" style={{ width: "100%" }}>
              {/* <DesignValue /> */}
            </div>
          </div>

        
    </ReactFlowProvider>
  );
};
export default Compare;
